import styles from './UserModal.module.css';

const UserModal = ({ user, onClose, onSuspendToggle }) => {
  if (!user) return null;
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h2>User Details</h2>
        <div className={styles.infoGrid}>
          <p><strong>ID:</strong> {user.id}</p>
          <p><strong>Email:</strong> {user.email}</p>
          <p><strong>Username:</strong> {user.username}</p>
          <p><strong>Sub UID:</strong> {user.sub_uid || '-'}</p>
          <p><strong>Is Active:</strong> {user.is_active ? 'Yes' : 'No'}</p>
          <p><strong>Is Staff:</strong> {user.is_staff ? 'Yes' : 'No'}</p>
          <p><strong>Bot Active:</strong> {user.is_bot_active ? 'Yes' : 'No'}</p>
        </div>
        <div className={styles.actions}>
          <button
            className={styles.suspendBtn}
            onClick={() => onSuspendToggle(user)}
          >
            {user.is_active ? 'Suspend User' : 'Reactivate User'}
          </button>
          <button className={styles.closeBtn} onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default UserModal;
